export default __webpack_public_path__ + "static/media/38.0797b441.jpg";